import { GitBranch, ListChecks, ShieldCheck, SquaresFour } from "@phosphor-icons/react"
import { Outlet, createFileRoute } from "@tanstack/react-router"

import { Module } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { type HeaderTab } from "~/components/reusable/HeaderTabs"
import NotFound from "~/components/reusable/NotFound"
import { usePageTracking } from "~/hooks/usePageTracking"
import { useFlags } from "~/features/feature-flags"
import { internalRouteGuard } from "~/utils/routeGuards"

/**
 * Ingestion Cockpit: one org's pipeline health, latest test run and view lineage. Staff-only until
 * it's opened to customers: drop the guard, swap `staffProcedure`, show the sidebar entry.
 */
export const Route = createFileRoute("/_auth/ingestion-cockpit/_layout")({
  staticData: { skipSkuStoreData: true },
  beforeLoad: internalRouteGuard,
  component: RouteComponent,
})

const tabs: HeaderTab[] = [
  { label: "Overview", path: "/ingestion-cockpit", icon: <SquaresFour /> },
  { label: "Data quality", path: "/ingestion-cockpit/data-quality", icon: <ListChecks /> },
  { label: "Data checks", path: "/ingestion-cockpit/data-checks", icon: <ShieldCheck /> },
  { label: "Views", path: "/ingestion-cockpit/views", icon: <GitBranch /> },
]

function RouteComponent() {
  usePageTracking("Ingestion Cockpit")
  const { ingestionCockpit: cockpitFlag } = useFlags()

  if (cockpitFlag === false) {
    return <NotFound />
  }

  return (
    <Module breadcrumb={<BreadcrumbWrapper />} tabs={{ items: tabs, path: "/ingestion-cockpit" }}>
      <Outlet />
    </Module>
  )
}
